import React, { lazy, Suspense } from 'react';

import clientOnly from '../../../hoc/clientOnly';

const EventCardComponent = lazy(() =>
  import(/* webpackChunkName: "EventCard" */ './EventCard')
);

const EventCard = props => (
  <Suspense fallback={null}>
    <EventCardComponent {...props} />
  </Suspense>
);

export default clientOnly(EventCard);
